<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {}
  },
  created() {
    document.title = '秦风智能crm';
  }
};
</script>

<style></style>
